import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';
import type {
  RecipientCountArgs,
  RecipientCountResponse,
  SendBroadcastRequest,
  SendBroadcastResponse,
} from 'types/interfaces/broadcast';

export const broadcastApi = createApi({
  reducerPath: 'broadcastApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getRecipientCount: builder.query<RecipientCountResponse, RecipientCountArgs>({
      query: ({ segment, messageType, targetUsername }) => {
        const params = new URLSearchParams({ segment, messageType });
        if (targetUsername) {
          params.set('targetUsername', targetUsername);
        }
        return {
          url: `/admin/broadcast/recipient-count?${params.toString()}`,
          method: 'GET',
          requiresAuth: true,
        };
      },
    }),

    sendBroadcast: builder.mutation<SendBroadcastResponse, SendBroadcastRequest>({
      query: (body) => ({
        url: '/admin/broadcast/send',
        method: 'POST',
        body,
        requiresAuth: true,
      }),
    }),
  }),
});

export const {
  useGetRecipientCountQuery,
  useSendBroadcastMutation,
} = broadcastApi;
